import { defineStore } from "pinia";
import { ref, computed } from "vue";
import axios from "@/plugins/axios";

export const usePersonMessagePreferencesStore = defineStore("personMessagePreferences", () => {
  // State
  const preferences = ref({});
  const loading = ref(false);

  // Getters
  const getPreferences = computed(() => (personId) => {
    return preferences.value[personId] || [];
  });
  const getIsLoading = computed(() => loading.value);

  // Actions
  const setPreferences = ({ personId, preferences: prefs }) => {
    preferences.value = {
      ...preferences.value,
      [personId]: prefs,
    };
  };

  const setLoading = (isLoading) => {
    loading.value = isLoading;
  };

  // API Actions
  const getPreferencesAction = async (personId) => {
    setLoading(true);
    try {
      const { data } = await axios.get(`/person/${personId}/message-preferences`);
      setPreferences({ personId, preferences: data.preferences });
      return data;
    } catch (error) {
      console.error("Failed to get preferences:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const updatePreferencesAction = async ({ personId, preferences: prefs }) => {
    setLoading(true);
    try {
      const { data } = await axios.post(`/person/${personId}/message-preferences`, {
        preferences: prefs,
      });

      // Update local state
      const currentPrefs = preferences.value[personId] || [];
      const updatedPrefs = Object.entries(prefs).map(([messageType, isEnabled]) => ({
        message_type: messageType,
        is_enabled: isEnabled,
      }));
      setPreferences({ personId, preferences: updatedPrefs });

      return data;
    } catch (error) {
      console.error("Failed to update preferences:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    // State
    preferences,
    loading,

    // Getters
    getPreferences,
    getIsLoading,

    // Actions
    setPreferences,
    setLoading,

    // API Actions
    getPreferencesAction,
    updatePreferencesAction,
  };
});
